/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerimeterPointDto } from './PerimeterPointDto';
import {
    PerimeterPointDtoFromJSON,
    PerimeterPointDtoFromJSONTyped,
    PerimeterPointDtoToJSON,
    PerimeterPointDtoToJSONTyped,
} from './PerimeterPointDto';

/**
 * 
 * @export
 * @interface ZoneResponseDto
 */
export interface ZoneResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ZoneResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ZoneResponseDto
     */
    siteId: string;
    /**
     * 
     * @type {string}
     * @memberof ZoneResponseDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ZoneResponseDto
     */
    latitude: number | null;
    /**
     * 
     * @type {number}
     * @memberof ZoneResponseDto
     */
    longitude: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ZoneResponseDto
     */
    isMain: boolean;
    /**
     * 
     * @type {Array<PerimeterPointDto>}
     * @memberof ZoneResponseDto
     */
    perimeter: Array<PerimeterPointDto> | null;
    /**
     * 
     * @type {Date}
     * @memberof ZoneResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ZoneResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the ZoneResponseDto interface.
 */
export function instanceOfZoneResponseDto(value: object): value is ZoneResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('siteId' in value) || value['siteId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('isMain' in value) || value['isMain'] === undefined) return false;
    if (!('perimeter' in value) || value['perimeter'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ZoneResponseDtoFromJSON(json: any): ZoneResponseDto {
    return ZoneResponseDtoFromJSONTyped(json, false);
}

export function ZoneResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ZoneResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'siteId': json['siteId'],
        'name': json['name'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'isMain': json['isMain'],
        'perimeter': (json['perimeter'] == null ? null : (json['perimeter'] as Array<any>).map(PerimeterPointDtoFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ZoneResponseDtoToJSON(json: any): ZoneResponseDto {
    return ZoneResponseDtoToJSONTyped(json, false);
}

export function ZoneResponseDtoToJSONTyped(value?: ZoneResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'siteId': value['siteId'],
        'name': value['name'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'isMain': value['isMain'],
        'perimeter': (value['perimeter'] == null ? null : (value['perimeter'] as Array<any>).map(PerimeterPointDtoToJSON)),
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

